<template>
  <div class="exchangeDetailsView">
    <div class="exchangeDetailsView__content">
      <div
        v-if="deviceVerificationResponse"
        class="exchangeDetailsView__content-lineItems"
      >
        <ExchangeLineItem
          v-if="getInboundProductDetails"
          heading-icon-class="inbound"
          :heading="translations.inboundLabel"
          :product-image="getInboundProductDetails.pvImageUrl"
          :product-display-name="getInboundProductDetails.pvName"
          :product-part-number="getInboundProductDetails.sku"
        />
        <ExchangeLineItem
          v-if="getOutboundProductDetails"
          heading-icon-class="outbound"
          class="exchangeDetailsView__content-lineItems-item"
          :heading="translations.outboundLabel"
          :product-image="getOutboundProductDetails.pvImageUrl"
          :product-display-name="getOutboundProductDetails.pvName"
          :product-part-number="getOutboundProductDetails.sku"
        />
      </div>
      <div
        v-if="hasOrderCreatedError"
        class="exchangeDetailsView__content--error"
      >
        {{ translations.orderCreatedFailureMessage }}
      </div>
      <div class="exchangeDetailsView__content--actions">
        <g-button
          role="button"
          :disabled="isCreateOrderButtonDisabled"
          @click="onOrderSubmit"
        >
          {{ translations.orderInformationForm.submitButtonText }}
        </g-button>
      </div>
    </div>
    <TheExchangeSidebar>
      <template #footer>
        <p
          v-if="isAutoRMAScenario"
          class="exchangeSidebar__description"
        >
          {{ translations.orderSummaryDescription }}
        </p>
        <p
          v-if="!outboundHasInventory"
          class="exchangeSidebar__description"
        >
          {{ translations.outOfStockMessage }}
        </p>
        <p
          v-if="renderUpgradeText"
          class="exchangeSidebar__description"
        >
          {{ translations.upgradeFirstSentence }}
          <a :href="constructUpgradeLink()">
            {{ translations.upgradeLinkedWords }}
          </a>
          {{ translations.upgradeSecondSentence }}
        </p>
      </template>
    </TheExchangeSidebar>
  </div>
</template>

<script src="./index.js"></script>

<style scoped lang="scss">
  @import './style.scss';
</style>
